import clientAxios from "../config/axios";
import { types } from "../types";
import { errorAlert, successAlert } from "./alerts";
import { setLoading, removeLoading, closeModal } from "./ui";

export const getCourses = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get("/api/v1/courses/all");
      dispatch({
        type: types.getCourse,
        payload: result.data,
      });
      
    } catch (error) {
      console.log(error.response);
    }
    dispatch(removeLoading());
  };
};

export const createCourse = (course) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.post("/api/v1/courses", course);
      dispatch({
        type: types.createCourse,
        payload: result.data,
      });
      dispatch(
        successAlert(`${result.statusText} Course Created`, result.status)
      );
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const updateCourse = (course) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.put(
        `/api/v1/courses/${course._id}`,
        course
      );
      dispatch({ type: types.updateCourse, payload: result.data.course });

      dispatch(
        successAlert(` ${result.statusText} Course Updated`, result.status)
      );
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const deleteCourse = (courseId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      await clientAxios.delete(`/api/v1/courses/${courseId}`);
      // await clientAxios.delete(`/api/v1/courses/${courseId}`, {
      //   params: { collegeId }, // <--- Esto es una req.query en server, no un params
      // });
      dispatch({
        type: types.deleteCourse,
        payload: courseId,
      });

      dispatch(closeModal()); //Mejorar
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

//Settings
export const setCourseToUpdating = (course) => {
  return (dispatch) => {
    dispatch({
      type: types.setCourseToUpdate,
      payload: course,
    });
  };
};

export const removeCourseFromUpdating = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeCourseFromUpdate,
    });
  };
};

export const setCourseToDeleting = (courseId) => {
  return (dispatch) => {
    dispatch({
      type: types.setCourseToDelete,
      payload: courseId,
    });
  };
};

export const removeCourseFromDeleting = () => {
  return (dispatch) => {
    dispatch({
      type: types.removeCourseFromDelete,
    });
  };
};
